import { API_BASE_URL } from "../constants";

const BASE_URL = `${API_BASE_URL}/app/api`;
export async function sendEmail(
  email: string,
  subject: string,
  text: string,
  emailType?: string,
  dataToSend?: Record<string, string>
) {
  const response = await fetch(`${BASE_URL}/sendMail`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      to: email,
      subject: subject,
      text: text,
      emailType: emailType,
      dataToSend: dataToSend,
    }),
  });

  if (!response.ok) {
    const errorDetails = await response.json().catch(() => null);
    throw new Error(errorDetails.message);
  }
}

export async function validatePasswordChangeLimit(
  email: string,
  subject: string,
  text: string,
  emailType?: string,
  dataToSend?: Record<string, string>
) {
  const response = await fetch(`${BASE_URL}/validatePasswordChangeLimit`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      to: email,
      subject: subject,
      text: text,
      emailType: emailType,
      dataToSend: dataToSend,
    }),
  });

  if (!response.ok) {
    const errorDetails = await response.json().catch(() => null);
    throw new Error(errorDetails.message);
  }
}
